<template>
  <div class="file-manager-content-body">
    <BContainer>
      <div v-if="!skeletonParameters" class="loader">
        <b-spinner />
      </div>
      <div v-if="skeletonParameters && skeletonParameters.type === 'vertical'" class="loader vertical">
        <b-spinner />
      </div>
    </BContainer>
  </div>
</template>

<script>
import { BContainer, BSpinner } from 'bootstrap-vue'

export default {
  name: 'Loader',
  components: {
    BContainer,
    BSpinner
  },
  props: ['skeletonParameters'],
  methods: {
    widthReact() {
      if (screen.width >= 576) {
        this.skeletonParameters.count = 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loader {
  color: var(--primary);
  transition: 0.15s ease-in opacity;
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  opacity: 1;
  &--visible {
    opacity: 0;
    pointer-events: all;
  }
}
.vertical {
  margin-top: 40%;
}

.dark-layout .loader {
  color: $dark-layout-purple !important;
}
</style>
